import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getPage, hasError } from '../../../states/page/selectors';
import { goBackPage, resetApp, pages, goToPreviousPage } from '../../../states/page/actions';
import CreditLandingPage from '../CreditLandingPage/CreditLandingPage';
import { fetchCalendar } from '../../../states/calendar/actions';
import CreditSubmittedPage from '../BacsSubmittedPage/CreditSubmittedPage/CreditSubmittedPage';
import DebitLandingPage from '../DebitLandingPage/DebitLandingPage';
import AddPayeeLayoutContainer from '../../../payees/components/LayoutContainer';
import DebitSubmittedPage from '../BacsSubmittedPage/DebitSubmittedPage/DebitSubmittedPage';
import DebitReviewPage from '../BacsReview/DebitReviewPage/DebitReviewPage';
import CreditReviewPage from '../BacsReview/CreditReviewPage/CreditReviewPage';
import DebitPaymentsPage from '../BacsPaymentsPage/DebitPaymentsPage';
import CreditPaymentsPage from '../BacsPaymentsPage/CreditPaymentsPage';
import { connectWrapper as DebitImportedPaymentsPage } from '../../../importedPayments/components/bacs/DebitImportedPaymentsPage';
import { connectWrapper as CreditImportedPaymentsPage } from '../../../importedPayments/components/bacs/CreditImportedPaymentsPage';
import {
	submitBacsPaymentsForReview,
	submitBacsConfirmed,
	submitBacsDebitPaymentsForReview,
	submitBacsDebitConfirmed,
} from '../../../states/api/bacsActions';
import { calendarTypes } from '../../../config';
import accountPropTypes from '../../../states/accounts/propTypes';
import {
	getBacsPaymentName,
	getImportedPayments,
	isBacsCreditTRAObligate,
	isBacsCreditFileUploadBatch,
} from '../../../states/bacsCredit/selectors';
import {
	getBacsPaymentName as getBacsDebitPaymentName,
	getBacsDebitImportedPayments,
	isBacsDebitTRAObligate,
	isBacsDebitFileUploadBatch,
} from '../../../states/bacsDebit/selectors';
import { getIsTemplateMode } from '../../../states/templates/selectors';
import BacsPayeePage from '../BacsPayeePage/BacsPayeePage';
import BacsDebitPayeePage from '../BacsPayeePage/BacsDebitPayeePage';
import AccountPickerPage from '../../../sharedComponents/AccountPickerPage/AccountPickerPage';
import { CONST_COLLECTION } from '../../../managePayments/constants/Constants';
import { PaymentType } from '../../../effectiveWarning/utils/constants';
import EffectiveWarningSMEContainer from '../../../effectiveWarning/EffectiveWarningSMEContainer';
import { resetEffectiveWarning } from '../../../effectiveWarning/state/actions';

const mapState = (state) => ({
	page: getPage(state),
	hasError: hasError(state),
	importedPaymentsData: getImportedPayments(state),
	importedBacsDebitPaymentsData: getBacsDebitImportedPayments(state),
	paymentName: getBacsPaymentName(state),
	debitPaymentName: getBacsDebitPaymentName(state),
	templateMode: getIsTemplateMode(state),
	isBacsTRAObligate: isBacsCreditTRAObligate(state) || isBacsDebitTRAObligate(state),
	isFileUploadBatch: isBacsCreditFileUploadBatch(state) || isBacsDebitFileUploadBatch(state),
});

const mapDispatch = (dispatch) => ({
	handleBack: () => dispatch(goBackPage()),
	resetApp: () => dispatch(resetApp),
	submitBacsPaymentsForReview: (beneficiaryId) => dispatch(submitBacsPaymentsForReview(beneficiaryId)),
	submitBacsConfirmed: () => dispatch(submitBacsConfirmed()),
	fetchCalendar: (calendarType) => dispatch(fetchCalendar(calendarType)),
	submitBacsDebitReview: () => dispatch(submitBacsDebitPaymentsForReview),
	submitBacsDebitConfirmed: () => dispatch(submitBacsDebitConfirmed()),
	resetEffectiveWarning: () => dispatch(resetEffectiveWarning()),
	goToPreviousPage: () => dispatch(goToPreviousPage()),
});

class LayoutContainer extends Component {
	constructor(props) {
		super(props);
		this.handleReset = this.handleReset.bind(this);
		this.handleBack = this.handleBack.bind(this);
		this.handleContinue = this.handleContinue.bind(this);
	}

	componentDidMount() {
		this.props.fetchCalendar(calendarTypes.CALENDAR_TYPE_BACS);
	}

	componentDidUpdate() {
		const { hasError, handleRoute } = this.props;
		if (hasError) {
			handleRoute('WEB-ERROR');
		}
	}

	handleBack() {
		const { handleBack, handleBackParent, page } = this.props;
		const useParentPages = [
			pages.BacsCreditLanding,
			pages.BacsCreditPayments,
			pages.BacsDebitLanding,
			pages.BacsDebitPayments,
		];

		if (handleBackParent && useParentPages.includes(page)) {
			handleBackParent();
			return;
		}
		handleBack();
	}
	//TODO - refactor this switch into separate functions (can probably be removed entirely just pass eg. submitBacsConfirmed as prop)
	handleContinue() {
		const { page, submitBacsPaymentsForReview, submitBacsConfirmed, submitBacsDebitConfirmed, submitBacsDebitReview } =
			this.props;

		switch (page) {
			case pages.BacsImportedCreditPaymentPage:
			case pages.BacsCreditPayments:
				submitBacsPaymentsForReview();
				break;
			case pages.BacsCreditReview:
			case pages.EffectiveWarning.warning:
			case pages.EffectiveWarning.paymentReason:
				submitBacsConfirmed();
				break;
			case pages.BacsImportedDebitPaymentPage:
			case pages.BacsDebitPayments:
				submitBacsDebitReview();
				break;
			case pages.BacsDebitReview:
				submitBacsDebitConfirmed();
				break;
			default:
				break;
		}
	}
	handleReset() {
		const { resetPaymentList, resetApp, fetchCalendar, resetEffectiveWarning } = this.props;
		resetApp();
		resetPaymentList();
		resetEffectiveWarning();
		fetchCalendar(calendarTypes.CALENDAR_TYPE_BACS);
	}
	renderPage() {
		const {
			copCheckTriggered,
			page,
			handleSelectPaymentType,
			handleDisplayFullwidth,
			handleRoute,
			handlePaymentInReview,
			isBootStrapInProgress,
			importedPaymentsData,
			importedBacsDebitPaymentsData,
			paymentName,
			debitPaymentName,
			templateMode,
			isBacsTRAObligate,
			isFileUploadBatch,
			goToPreviousPage,
			content,
			sessionCOPChecks,
		} = this.props;

		switch (page) {
			case pages.BacsCreditLanding:
				return (
					<CreditLandingPage
						handleSelectPaymentType={handleSelectPaymentType}
						handleDisplayFullwidth={handleDisplayFullwidth}
						isBootStrapInProgress={isBootStrapInProgress}
						handleBack={this.handleBack}
					/>
				);
			case pages.BacsCreditPayments:
				return (
					<CreditPaymentsPage
						copCheckTriggered={copCheckTriggered}
						handleContinue={this.handleContinue}
						handleDisplayFullwidth={handleDisplayFullwidth}
						handleBack={this.handleBack}
						sessionCOPChecks={sessionCOPChecks}
						templateMode={templateMode}
					/>
				);
			case pages.BacsImportedCreditPaymentPage:
				return (
					<div className="container container--lg">
						<CreditImportedPaymentsPage
							handleContinue={this.handleContinue}
							handleDisplayFullwidth={handleDisplayFullwidth}
							handlePaymentInReview={handlePaymentInReview}
							handleBack={this.handleBack}
							importedPaymentFileName={paymentName}
							importedPaymentsData={importedPaymentsData}
						/>
					</div>
				);
			case pages.BacsCreditReview: {
				const contentKey = isBacsTRAObligate ? 'traObligateContent' : 'content';
				return (
					<CreditReviewPage
						handleContinue={this.handleContinue}
						handleBack={this.handleBack}
						handleRoute={handleRoute}
						handlePaymentInReview={handlePaymentInReview}
						contentKey={contentKey}
					/>
				);
			}
			case pages.BacsCreditSubmitted:
				return <CreditSubmittedPage handleRoute={handleRoute} handleReset={this.handleReset} />;
			case pages.BacsDebitLanding:
				return (
					<DebitLandingPage
						handleSelectPaymentType={handleSelectPaymentType}
						handleDisplayFullwidth={handleDisplayFullwidth}
						handleBack={this.handleBack}
						isBootStrapInProgress={isBootStrapInProgress}
					/>
				);
			case pages.BacsDebitPayments:
				return (
					<DebitPaymentsPage
						handleContinue={this.handleContinue}
						handleDisplayFullwidth={handleDisplayFullwidth}
						handleBack={this.handleBack}
						templateMode={templateMode}
					/>
				);
			case pages.BacsImportedDebitPaymentPage:
				return (
					<div className="container container--lg">
						<DebitImportedPaymentsPage
							handleContinue={this.handleContinue}
							handleDisplayFullwidth={handleDisplayFullwidth}
							handlePaymentInReview={handlePaymentInReview}
							handleBack={this.handleBack}
							importedPaymentFileName={debitPaymentName}
							importedPaymentsData={importedBacsDebitPaymentsData}
						/>
					</div>
				);
			case pages.BacsDebitReview: {
				const contentKey = isBacsTRAObligate ? 'traObligateContent' : 'content';
				return (
					<DebitReviewPage
						handleContinue={this.handleContinue}
						handleBack={this.handleBack}
						handleRoute={handleRoute}
						handlePaymentInReview={handlePaymentInReview}
						contentKey={contentKey}
					/>
				);
			}
			case pages.BacsDebitSubmitted:
				return <DebitSubmittedPage handleRoute={handleRoute} handleReset={this.handleReset} />;
			case pages.Payee:
				return (
					<div className="container container--lg">
						<AddPayeeLayoutContainer
							copCheckTriggered={copCheckTriggered}
							handleRoute={handleRoute}
							sessionCOPChecks={sessionCOPChecks}
						/>
					</div>
				);
			case pages.BacsCreditPayeeSelector:
				return (
					<BacsPayeePage
						copCheckTriggered={copCheckTriggered}
						handleDisplayFullwidth={handleDisplayFullwidth}
						sessionCOPChecks={sessionCOPChecks}
					/>
				);
			case pages.BacsDebitPayeeSelector:
				return (
					<BacsDebitPayeePage
						copCheckTriggered={copCheckTriggered}
						handleDisplayFullwidth={handleDisplayFullwidth}
						paymentMode={CONST_COLLECTION}
						sessionCOPChecks={sessionCOPChecks}
					/>
				);
			case pages.BacsCreditAccountPicker: {
				const bacsCreditAccountPickerPageId = isFileUploadBatch
					? pages.BacsImportedCreditPaymentPage
					: pages.BacsCreditLanding;
				return <AccountPickerPage pageId={bacsCreditAccountPickerPageId} />;
			}
			case pages.BacsDebitAccountPicker: {
				const bacsDebitAccountPickerPageId = isFileUploadBatch
					? pages.BacsImportedDebitPaymentPage
					: pages.BacsDebitLanding;
				return <AccountPickerPage pageId={bacsDebitAccountPickerPageId} paymentMode={CONST_COLLECTION} />;
			}
			case pages.EffectiveWarning.paymentReason:
			case pages.EffectiveWarning.warning:
			case pages.EffectiveWarning.paymentCancelled:
				return (
					<div className="container container--lg">
						<EffectiveWarningSMEContainer
							payType={PaymentType.BACS_CREDIT}
							listPayType={PaymentType.BACS_CREDIT}
							batchPayType={PaymentType.BACS_CREDIT}
							onContinue={this.handleContinue}
							onError={() => handleRoute('WEB-HOMEPAGE')} // REFACTOR: looks like this is never used
							onCancel={this.handleReset}
							handleBack={goToPreviousPage}
							startPage={page}
							handlePaymentInReview={handlePaymentInReview}
							handleRoute={handleRoute}
							content={content}
						/>
					</div>
				);
			default:
				return <span />;
		}
	}

	render() {
		return <div>{this.renderPage()}</div>;
	}
}

LayoutContainer.defaultProps = {
	handleDisplayFullwidth: () => {},
	handlePaymentInReview: () => {},
};

LayoutContainer.propTypes = {
	resetPaymentList: PropTypes.func,
	resetApp: PropTypes.func,
	page: PropTypes.string.isRequired,
	handleBack: PropTypes.func.isRequired,
	handleBackParent: PropTypes.func,
	hasError: PropTypes.bool,
	handleRoute: PropTypes.func.isRequired,
	handleSelectPaymentType: PropTypes.func,
	submitBacsConfirmed: PropTypes.func.isRequired,
	fetchCalendar: PropTypes.func,
	handleDisplayFullwidth: PropTypes.func,
	submitBacsDebitConfirmed: PropTypes.func.isRequired,
	submitBacsDebitReview: PropTypes.func.isRequired,
	handlePaymentInReview: PropTypes.func,
	submitBacsPaymentsForReview: PropTypes.func.isRequired,
	isBootStrapInProgress: PropTypes.bool.isRequired,
	importedPaymentsData: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	importedBacsDebitPaymentsData: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	paymentName: PropTypes.string.isRequired,
	debitPaymentName: PropTypes.string.isRequired,
	templateMode: PropTypes.bool.isRequired,
	isBacsTRAObligate: PropTypes.bool.isRequired,
	isFileUploadBatch: PropTypes.bool.isRequired,
	resetEffectiveWarning: PropTypes.func,
	goToPreviousPage: PropTypes.func,
	copCheckTriggered: PropTypes.func,
	sessionCOPChecks: PropTypes.object,
};

export default connect(mapState, mapDispatch)(LayoutContainer);
